import { TemplateElement, html, defineElement } from '@webtides/element-js';
import i18n from '../../../../utils/i18n.js';

/**
 * @property {string} templateId
 * @property {string} title
 */
export default class FeedbackButton extends TemplateElement {
    properties() {
        return {
            templateId: '',
            title: '',
        };
    }

    connected() {
        this.checkState();
    }

    checkState() {
        let localStorageItem = window.localStorage.getItem('jsFeedback');
        if (localStorageItem && JSON.parse(localStorageItem)[this.templateId]) {
            this.$refs.thankYouContent.classList.add('show');
            this.classList.add('has-feedback');
        }
    }

    onFeedbackClick(e) {
        e.preventDefault();

        this.$refs.thankYouContent.classList.add('show');
        this.classList.add('has-feedback');

        window.localStorage.setItem(
            'jsFeedback',
            JSON.stringify({
                ...(JSON.parse(window.localStorage.getItem('jsFeedback')) || {}),
                [this.templateId]: true,
            }),
        );
    }

    events() {
        return {
            '[ref="feedbackButton"]': {
                click: (e) => {
                    this.onFeedbackClick(e);
                },
            },
        };
    }

    template() {
        return html`
            <div class="SupportButtons--section">
                <h2 class="SupportButtons--title">${this.title}</h2>
                <div class="FeedbackButtons" data-js-feedback="data-js-feedback" id="${this.templateId}">
                    <div class="FeedbackButton is-yes">
                        <div class="FeedbackButton--icons">
                            <a
                                ref="feedbackButton"
                                class="FeedbackButton--link"
                                href=""
                                data-js-feedback-btn="data-js-feedback-btn"
                                data-tracking='{"event":"generic","category":"interaction","action":"body","label":"gefaellt"}'
                            >
                                ${i18n('feedbackButton.yes')}
                            </a>
                        </div>
                        <div
                            class="FeedbackButton--thankYou"
                            ref="thankYouContent"
                            data-js-feedback-thankyou="data-js-feedback-thankyou"
                        >
                            ${i18n('feedbackButton.thankYou')}
                        </div>
                    </div>
                    <div class="FeedbackButton is-no">
                        <div class="FeedbackButton--icons">
                            <a
                                ref="feedbackButton"
                                class="FeedbackButton--link"
                                href=""
                                data-js-feedback-btn="data-js-feedback-btn"
                                data-tracking='{"event":"generic","category":"interaction","action":"body","label":"gefaellt nicht"}'
                            >
                                ${i18n('feedbackButton.no')}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        `;
    }
}

defineElement('mb-feedback-button', FeedbackButton);
